import styled from "styled-components";

export const RequestShiftData = styled.div`
  background-color: #F8F9FA;
  border-radius: 20px;
  padding: 2rem 0 3rem;
  margin-top: .7rem;
  
  @media (max-width: 992px) {
    padding: 2rem 1.5rem 3rem;
  } 
`;

export const FormValidationRoute = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: calc(100% - 66px);
  top: calc(50px / 2 + 25px);
  right: -40px;
  
  @media (max-width: 992px) {
    right: -34px;
    height: calc(100% - 141px);
    top: calc(50px / 2 + 64px);
  }
`;

export const FormValidationCircle = styled.div`
  background-color:  ${props => props.active ? 'var(--accent-success-color)' : 'var(--gray-color)'};
  width: 18px;
  height: 18px;
  border-radius: 50%;
`;

export const FormValidationBorder = styled.div`
  flex-grow: 1;
  width: 1px;
  margin: .5rem 0;
  background-image: linear-gradient(to bottom, var(--gray-color) 60%, rgba(255,255,255,0) 40%);
  background-position: bottom;
  background-size: 1px 12px;
  background-repeat: repeat-y;
`;

export const FormValidationSquare = styled.div`
  background-color: ${props => props.active ? 'var(--warning-color)' : 'var(--gray-color)'};
  width: 18px;
  height: 18px;
  border-radius: 4px;
`;
